import { useState } from 'react';
import { ethers, BigNumber, utils } from 'ethers';
import { Box, Flex, Input, useMediaQuery } from '@chakra-ui/react';
import abi from '../abi.json';
import ButtonPress from './ButtonPress';

const contractAddress = '0xf69a205fF47FF3235dbf0f1e2A8765357fc2e81E';

const MainMint = ({ accounts, setAccounts}) => {

    const [mintAmount, setMintAmount] = useState(20);
    const isConnected = Boolean(accounts[0]);
    const [isLargerThan550] = useMediaQuery('(min-width: 550px)');
    const [isLargerThan800] = useMediaQuery('(min-width: 800px)');

    async function getPrice() {

        const RPC = process.env.REACT_APP_INFURA_LINK;
        const provider = new ethers.providers.JsonRpcProvider(RPC);
        const contract = new ethers.Contract(contractAddress, abi, provider);
        const result = await contract.price();
        const price = utils.formatEther(result);
        return price;
    }
    
    async function handleMint() {
        if (window.ethereum) {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const price = (await getPrice()).toString();
            const contract = new ethers.Contract(
                contractAddress,
                abi,
                signer
            );

            try {
                const response = await contract.mintPublic(BigNumber.from(mintAmount), {
                    value: utils.parseEther((price * mintAmount).toString()),
                });
                console.log('response: ', response);
            } catch(err) {
                console.log('error: ', err);
            }
        }
    }

    const handleDecrement = () => {
        if (mintAmount <= 1) return;
        setMintAmount(mintAmount - 1);
    };

    const handleIncrement = () => {
        if (mintAmount >= 20) return;
        setMintAmount(mintAmount + 1);
    };
    
    return (
        <Flex
            justify='center'
            align='center'
            width='100%'
            marginTop={ isLargerThan550 ? '' : '50px'}
            position={isLargerThan800 ? 'absolute' : ''}
            top={isLargerThan800 ? '56%' : ''}
            transform={isLargerThan800 ? 'translateY(-50%)' : ''}
        >
            <Box>
                <Flex justify='center' align='center' padding='20px' flexDirection={isLargerThan550 ? 'row' : 'column'}>
                    <Flex flexDirection='column'>
                        {isConnected ? (
                        <div>
                            <Flex align='center' justify='center'>
                                <ButtonPress
                                    backgroundColor='#6a6e74'
                                    borderRadius='5px'
                                    boxShadow='2px 2px 2px 1px #0F0F0F'
                                    color='white'
                                    cursor='pointer'
                                    fontFamily='inherit'
                                    padding='15px'
                                    marginTop='10px'
                                    onClick={handleDecrement}
                                >
                                    -
                                </ButtonPress>
                                <Input
                                    readOnly
                                    fontFamily='inherit'
                                    width='100px'
                                    height='40px'
                                    textAlign='center'
                                    paddingLeft='19px'
                                    marginTop='10px'
                                    type='number'
                                    value={mintAmount}
                                />
                                <ButtonPress
                                    backgroundColor='#6a6e74'
                                    borderRadius='5px'
                                    boxShadow='2px 2px 2px 1px #0F0F0F'
                                    color='white'
                                    cursor='pointer'
                                    fontFamily='inherit'
                                    padding='15px'
                                    marginTop='10px'
                                    onClick={handleIncrement}
                                >
                                    +
                                </ButtonPress>
                            </Flex>
                            <ButtonPress
                                backgroundColor='#6a6e74'
                                borderRadius='5px'
                                boxShadow='2px 2px 2px 1px #0F0F0F'
                                color='white'
                                cursor='pointer'
                                fontFamily='inherit'
                                fontSize='30px'
                                padding='16px 10px 10px 10px'
                                marginTop='10px'                            
                                onClick={handleMint}
                            >   
                                MINT
                            </ButtonPress>
                        </div>
                    ) : (
                        <p
                            fontSize='38px'
                        >Connect your wallet.</p>
                    )}
                    </Flex>
                </Flex>
            </Box>
        </Flex>
    );
};

export default MainMint;